import React from "react";

import config from './Config';

export default function PrivacyPolicy() {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Privacy Policy</h1>
        <p style={styles.text}>
          Welcome to <strong>{config.brandname}</strong>. Your privacy is important to us.
          This Privacy Policy explains how we collect, use, and protect your
          information when you use our application and related services.
        </p>

        <h2 style={styles.subtitle}>1. Information We Collect</h2>
        <p style={styles.text}>
          We may collect information such as your name and email address to provide better services and improve your
          experience.
        </p>

        <h2 style={styles.subtitle}>2. How We Use Your Information</h2>
        <p style={styles.text}>
          Your data is used to personalize your experience, communicate updates,
          and improve our app’s performance and security.
        </p>

        <h2 style={styles.subtitle}>3. Data Protection</h2>
        <p style={styles.text}>
          We implement appropriate technical and organizational measures to
          safeguard your data against unauthorized access, alteration, or
          disclosure.
        </p>

        <h2 style={styles.subtitle}>4. Sharing Information</h2>
        <p style={styles.text}>
          We do not sell, trade, or rent users’ personal identification
          information to others. Information may be shared only with trusted
          partners who assist in operating the app.
        </p>

        <h2 style={styles.subtitle}>5. Your Consent</h2>
        <p style={styles.text}>
          By using <strong>{config.brandname}</strong>, you consent to our Privacy Policy.
          If you do not agree, please discontinue use of the app.
        </p>

        <h2 style={styles.subtitle}>6. Updates to This Policy</h2>
        <p style={styles.text}>
          We may update this policy periodically. Changes will be posted within
          the app, and continued use signifies acceptance.
        </p>

        <h2 style={styles.subtitle}>7. Contact Us</h2>
        <p style={styles.text}>
          If you have any questions about this Privacy Policy, please contact us
          at <a href={"mailto:" + config.supportemail} style={styles.link}>
            {config.supportemail}
          </a>.
        </p>

        <p style={styles.footer}>Last updated: October 7, 2025</p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    padding: "40px 20px",
    backgroundColor: "#fafafa",
  },
  card: {
    maxWidth: "800px",
    backgroundColor: "#fff",
    padding: "40px",
    borderRadius: "20px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  },
  title: {
    color: "#ff7b00",
    textAlign: "center",
    marginBottom: "20px",
  },
  subtitle: {
    color: "#333",
    marginTop: "30px",
  },
  text: {
    lineHeight: "1.6",
    color: "#555",
    marginTop: "10px",
  },
  link: {
    color: "#ff7b00",
    textDecoration: "none",
  },
  footer: {
    textAlign: "center",
    color: "#888",
    fontSize: "14px",
    marginTop: "40px",
  },
};